/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { CreateOrganizationDto } from "../types/createOrganizationDto";

import type { FormerOrganizationDto } from "../types/formerOrganizationDto";

import type { OrganizationDto } from "../types/organizationDto";

import type { OrganizationMemberDto } from "../types/organizationMemberDto";

import type { OrganizationSettingsDto } from "../types/organizationSettingsDto";

import type { ProblemDetails } from "../types/problemDetails";

import type { RestoreOrganizationResultDto } from "../types/restoreOrganizationResultDto";

import type { SetLogoDto } from "../types/setLogoDto";

import type { TransferOrganizationDto } from "../types/transferOrganizationDto";

import type { UpdateOrganizationDto } from "../types/updateOrganizationDto";

import type { UserOrganizationsResponse } from "../types/userOrganizationsResponse";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const getUserOrganizations = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserOrganizationsResponse>> => {
  return axios.default.get(`/api/organizations`, options);
};

export const getGetUserOrganizationsQueryKey = () => {
  return [`/api/organizations`] as const;
};

export const getGetUserOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserOrganizations>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getUserOrganizations>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserOrganizationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserOrganizations>>
  > = ({ signal }) => getUserOrganizations({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserOrganizations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserOrganizations>>
>;
export type GetUserOrganizationsQueryError = AxiosError<unknown>;

export function useGetUserOrganizations<
  TData = Awaited<ReturnType<typeof getUserOrganizations>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getUserOrganizations>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserOrganizationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createOrganization = (
  createOrganizationDto: CreateOrganizationDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationDto>> => {
  return axios.default.post(
    `/api/organizations`,
    createOrganizationDto,
    options,
  );
};

export const getCreateOrganizationMutationOptions = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganization>>,
    TError,
    { data: CreateOrganizationDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrganization>>,
  TError,
  { data: CreateOrganizationDto },
  TContext
> => {
  const mutationKey = ["createOrganization"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrganization>>,
    { data: CreateOrganizationDto }
  > = (props) => {
    const { data } = props ?? {};

    return createOrganization(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrganization>>
>;
export type CreateOrganizationMutationBody = CreateOrganizationDto;
export type CreateOrganizationMutationError = AxiosError<ProblemDetails>;

export const useCreateOrganization = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganization>>,
    TError,
    { data: CreateOrganizationDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOrganization>>,
  TError,
  { data: CreateOrganizationDto },
  TContext
> => {
  const mutationOptions = getCreateOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_UPDATE
 */
export const updateCurrentOrganization = (
  updateOrganizationDto: UpdateOrganizationDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationDto>> => {
  return axios.default.patch(
    `/api/organizations/current`,
    updateOrganizationDto,
    options,
  );
};

export const getUpdateCurrentOrganizationMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentOrganization>>,
    TError,
    { data: UpdateOrganizationDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCurrentOrganization>>,
  TError,
  { data: UpdateOrganizationDto },
  TContext
> => {
  const mutationKey = ["updateCurrentOrganization"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCurrentOrganization>>,
    { data: UpdateOrganizationDto }
  > = (props) => {
    const { data } = props ?? {};

    return updateCurrentOrganization(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCurrentOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCurrentOrganization>>
>;
export type UpdateCurrentOrganizationMutationBody = UpdateOrganizationDto;
export type UpdateCurrentOrganizationMutationError =
  AxiosError<ProblemDetails | void>;

export const useUpdateCurrentOrganization = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentOrganization>>,
    TError,
    { data: UpdateOrganizationDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCurrentOrganization>>,
  TError,
  { data: UpdateOrganizationDto },
  TContext
> => {
  const mutationOptions = getUpdateCurrentOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_UPDATE
 */
export const setLogo = (
  setLogoDto: SetLogoDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.default.post(
    `/api/organizations/current/logo`,
    setLogoDto,
    options,
  );
};

export const getSetLogoMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setLogo>>,
    TError,
    { data: SetLogoDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setLogo>>,
  TError,
  { data: SetLogoDto },
  TContext
> => {
  const mutationKey = ["setLogo"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setLogo>>,
    { data: SetLogoDto }
  > = (props) => {
    const { data } = props ?? {};

    return setLogo(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetLogoMutationResult = NonNullable<
  Awaited<ReturnType<typeof setLogo>>
>;
export type SetLogoMutationBody = SetLogoDto;
export type SetLogoMutationError = AxiosError<ProblemDetails | void>;

export const useSetLogo = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setLogo>>,
    TError,
    { data: SetLogoDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof setLogo>>,
  TError,
  { data: SetLogoDto },
  TContext
> => {
  const mutationOptions = getSetLogoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_UPDATE
 */
export const deleteLogo = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.default.delete(`/api/organizations/current/logo`, options);
};

export const getDeleteLogoMutationOptions = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLogo>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLogo>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["deleteLogo"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLogo>>,
    void
  > = () => {
    return deleteLogo(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLogoMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLogo>>
>;

export type DeleteLogoMutationError = AxiosError<void>;

export const useDeleteLogo = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLogo>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLogo>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteLogoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const leaveOrganization = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.default.post(
    `/api/organizations/current/leave`,
    undefined,
    options,
  );
};

export const getLeaveOrganizationMutationOptions = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof leaveOrganization>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof leaveOrganization>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["leaveOrganization"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof leaveOrganization>>,
    void
  > = () => {
    return leaveOrganization(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LeaveOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof leaveOrganization>>
>;

export type LeaveOrganizationMutationError = AxiosError<ProblemDetails>;

export const useLeaveOrganization = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof leaveOrganization>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof leaveOrganization>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getLeaveOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getFormerOrganizations = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FormerOrganizationDto[]>> => {
  return axios.default.get(`/api/organizations/former`, options);
};

export const getGetFormerOrganizationsQueryKey = () => {
  return [`/api/organizations/former`] as const;
};

export const getGetFormerOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFormerOrganizations>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFormerOrganizations>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFormerOrganizationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFormerOrganizations>>
  > = ({ signal }) => getFormerOrganizations({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFormerOrganizations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFormerOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFormerOrganizations>>
>;
export type GetFormerOrganizationsQueryError = AxiosError<unknown>;

export function useGetFormerOrganizations<
  TData = Awaited<ReturnType<typeof getFormerOrganizations>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFormerOrganizations>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFormerOrganizationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const restoreOrganization = (
  organizationId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RestoreOrganizationResultDto>> => {
  return axios.default.post(
    `/api/organizations/${organizationId}/restore`,
    undefined,
    options,
  );
};

export const getRestoreOrganizationMutationOptions = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreOrganization>>,
    TError,
    { organizationId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreOrganization>>,
  TError,
  { organizationId: string },
  TContext
> => {
  const mutationKey = ["restoreOrganization"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreOrganization>>,
    { organizationId: string }
  > = (props) => {
    const { organizationId } = props ?? {};

    return restoreOrganization(organizationId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreOrganization>>
>;

export type RestoreOrganizationMutationError = AxiosError<ProblemDetails>;

export const useRestoreOrganization = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreOrganization>>,
    TError,
    { organizationId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreOrganization>>,
  TError,
  { organizationId: string },
  TContext
> => {
  const mutationOptions = getRestoreOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_TRANSFER
 */
export const getTransferCandidates = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationMemberDto[]>> => {
  return axios.default.get(
    `/api/organizations/current/transfer-candidates`,
    options,
  );
};

export const getGetTransferCandidatesQueryKey = () => {
  return [`/api/organizations/current/transfer-candidates`] as const;
};

export const getGetTransferCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTransferCandidates>>,
  TError = AxiosError<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTransferCandidates>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransferCandidatesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTransferCandidates>>
  > = ({ signal }) => getTransferCandidates({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransferCandidates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTransferCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransferCandidates>>
>;
export type GetTransferCandidatesQueryError = AxiosError<void>;

export function useGetTransferCandidates<
  TData = Awaited<ReturnType<typeof getTransferCandidates>>,
  TError = AxiosError<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTransferCandidates>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTransferCandidatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_TRANSFER
 */
export const transferOrganization = (
  transferOrganizationDto: TransferOrganizationDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationDto>> => {
  return axios.default.post(
    `/api/organizations/current/transfer`,
    transferOrganizationDto,
    options,
  );
};

export const getTransferOrganizationMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferOrganization>>,
    TError,
    { data: TransferOrganizationDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transferOrganization>>,
  TError,
  { data: TransferOrganizationDto },
  TContext
> => {
  const mutationKey = ["transferOrganization"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transferOrganization>>,
    { data: TransferOrganizationDto }
  > = (props) => {
    const { data } = props ?? {};

    return transferOrganization(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransferOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof transferOrganization>>
>;
export type TransferOrganizationMutationBody = TransferOrganizationDto;
export type TransferOrganizationMutationError =
  AxiosError<ProblemDetails | void>;

export const useTransferOrganization = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferOrganization>>,
    TError,
    { data: TransferOrganizationDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof transferOrganization>>,
  TError,
  { data: TransferOrganizationDto },
  TContext
> => {
  const mutationOptions = getTransferOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getOrganizationSettings = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationSettingsDto>> => {
  return axios.default.get(`/api/organizations/current/settings`, options);
};

export const getGetOrganizationSettingsQueryKey = () => {
  return [`/api/organizations/current/settings`] as const;
};

export const getGetOrganizationSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationSettings>>
  > = ({ signal }) => getOrganizationSettings({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSettings>>
>;
export type GetOrganizationSettingsQueryError = AxiosError<unknown>;

export function useGetOrganizationSettings<
  TData = Awaited<ReturnType<typeof getOrganizationSettings>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSettings>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrganizationSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_UPDATE
 */
export const updateOrganizationSettings = (
  organizationSettingsDto: OrganizationSettingsDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationSettingsDto>> => {
  return axios.default.put(
    `/api/organizations/current/settings`,
    organizationSettingsDto,
    options,
  );
};

export const getUpdateOrganizationSettingsMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganizationSettings>>,
    TError,
    { data: OrganizationSettingsDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganizationSettings>>,
  TError,
  { data: OrganizationSettingsDto },
  TContext
> => {
  const mutationKey = ["updateOrganizationSettings"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganizationSettings>>,
    { data: OrganizationSettingsDto }
  > = (props) => {
    const { data } = props ?? {};

    return updateOrganizationSettings(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganizationSettings>>
>;
export type UpdateOrganizationSettingsMutationBody = OrganizationSettingsDto;
export type UpdateOrganizationSettingsMutationError =
  AxiosError<ProblemDetails | void>;

export const useUpdateOrganizationSettings = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganizationSettings>>,
    TError,
    { data: OrganizationSettingsDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganizationSettings>>,
  TError,
  { data: OrganizationSettingsDto },
  TContext
> => {
  const mutationOptions = getUpdateOrganizationSettingsMutationOptions(options);

  return useMutation(mutationOptions);
};
